import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { withStyles } from '@material-ui/core';
import { sGetDocuments } from '../../../../store/reducers/documents';
import styles from './style';
import Overview from './Overview';
import Box from '../../../../components/atomic/Box';
import useDesktop from '../../../../hooks/useDesktop';
import Route from '../../../../components/atomic/Route';
import Hidden from '../../../../components/atomic/Hidden';
import PageLayout from '../../../../components/layouts/WithHeader';
import { sGetActiveProperty } from '../../../../store/reducers/properties';
import { acSetDocumentSearchText } from '../../../../store/actions/documents';
import { SmallScreenHeader } from './SmallScreenHeader';
import { ErrorMessage } from './ErrorMessage';
import PropertyFinancials from '../PropertyFinancials';

export const Home = ({
  classes,
  activeProperty,
  fetchingProperties,
  fetchingPropertiesError,
  setSearchText,
  documents,
}) => {
  const match = useRouteMatch();
  const isDesktop = useDesktop();
  const financialsUrl = `${match.url}/financials`;

  useEffect(() => {
    setSearchText('');
  }, []);

  if (fetchingPropertiesError) {
    return <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />;
  }

  return (
    <>
      <PageLayout
        hideHeader
        minFullHeight
        lessMarginLeft={isDesktop}
        noPaddingTop
        noPadding={!isDesktop}
        safePaddingEnabled={false}
        maxWidth="lg"
      >
        <SmallScreenHeader
          classes={classes}
          activeProperty={activeProperty}
          fetchingProperties={fetchingProperties}
          fetchingPropertiesError={fetchingPropertiesError}
        />
        {fetchingPropertiesError && (
          <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />
        )}
        {!fetchingPropertiesError && (
          <Hidden mdUp>
            <Route exact path={match.url}>
              <Box p={1}>
                <Overview
                  documents={documents}
                  property={activeProperty}
                  fetchingProperty={fetchingProperties}
                  fetchingPropertyError={fetchingPropertiesError}
                />
              </Box>
            </Route>

            <Route exact path={financialsUrl}>
              <PropertyFinancials />
            </Route>
          </Hidden>
        )}
        {/* Desktop only */}
        <Hidden smDown>
          {!fetchingPropertiesError && (
            <Box p={1}>
              <Overview
                documents={documents}
                property={activeProperty}
                fetchingProperty={fetchingProperties}
                fetchingPropertyError={fetchingPropertiesError}
              />
            </Box>
          )}
          {fetchingPropertiesError && (
            <ErrorMessage fetchingPropertiesError={fetchingPropertiesError} />
          )}
        </Hidden>
      </PageLayout>
    </>
  );
};

const mapStateToProps = (state) => ({
  activeProperty: sGetActiveProperty(state),
  documents: sGetDocuments(state),
});

const mapDispatchToProps = (dispatch) => ({
  setSearchText: (searchText) => dispatch(acSetDocumentSearchText(searchText)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Home));
